export const getQueryParams = (
  params: Record<string, string | number | boolean | string[]>
): string => {
  const queryParams: string[] = [];

  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      const value = params[key];
      if (Array.isArray(value)) {
        for (const item of value) {
          addParamsToQuery(queryParams, item, key);
        }
      } else {
        addParamsToQuery(queryParams, value, key);
      }
    }
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return queryString;
};

const addParamsToQuery = (queryParams: string[], value: string | number | boolean, key: string) => {
  if (value !== undefined && value !== null && value !== '') {
    queryParams.push(`${key}=${encodeURIComponent(value)}`);
  }
};
